import { AppStore } from "./pages";

export const store = {
    appStore: new AppStore()
};
